import { Link } from 'react-router-dom';
import { Authenticator, CheckboxField, useAuthenticator } from '@aws-amplify/ui-react';
import { Button } from '@mantine/core';
// import Header from '@components/header';

const signUp = {
  SignUp: {
    FormFields() {
      const { validationErrors } = useAuthenticator();

      return (
        <>
          <Authenticator.SignUp.FormFields />
          <CheckboxField
            errorMessage={validationErrors.acknowledgement as string}
            hasError={!!validationErrors.acknowledgement}
            name="acknowledgement"
            value="yes"
            label="I agree with the Terms and Conditions"
          />
          <Button type="submit" variant="light" fullWidth component={Link} to="/">
            Cancel
          </Button>
        </>
      );
    },
  },
};

const components = {
  // Header,
  ...signUp,
};

console.log('components: ', components);
export { components };
